<template>
  <v-dialog v-model="dialog" scrollable max-width="900" @click:outside="onCloseDialog" @keydown.esc="onCloseDialog">
    <v-card class="py-3">
      <v-card-title class="subheadline">
        <v-icon small> far fa-paper-plane </v-icon>
        <span class="ml-2">Actualiza tu plan</span>
        <v-spacer />
        <v-btn rounded small text color="primary" outlined class="mr-2" @click="onManageSubscription">
          Administrar suscripción
        </v-btn>
        <v-btn icon @click="onCloseDialog">
          <v-icon small> fas fa-times </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <StripeCheckout
          ref="checkoutRef"
          mode="subscription"
          :pk="publishableKey"
          :line-items="lineItems"
          :success-url="successURL"
          :cancel-url="cancelURL"
          :customer-email="getAgent.email"
          :client-reference-id="getAgent.uid"
          @loading="(v) => (loading = v)"
        />
        <v-row class="text-center">
          <v-col v-for="plan in getPlans" :key="plan.id" :cols="12" sm="3">
            <v-card class="py-5">
              <h3 class="mb-5">Plan {{ plan.name }}</h3>
              <h1 class="text--secondary font-weight-thin mb-10">
                {{ plan.price }}
                <span class="text-body-1">/mes</span>
              </h1>
              <div v-for="feature in plan.features" :key="feature" class="px-3">
                <p>{{ feature }}</p>
              </div>
              <v-btn
                v-if="getSubscription.type === plan.id && !getSubscription.cancel_at_period_end"
                color="primary"
                outlined
                rounded
                class="black--text text--darken-1 mt-3"
              >
                <v-icon small class="mr-2 accent--text"> fas fa-check </v-icon>Plan actual
              </v-btn>
              <v-btn
                v-else
                :loading="loading && planSelected === plan.id"
                rounded
                color="accent"
                class="black--text mt-3"
                :disabled="plan.level < getPlans[getSubscription.type].level"
                @click="onSelectPlan(plan.id)"
              >
                Seleccionar plan
              </v-btn>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { StripeCheckout } from "@vue-stripe/vue-stripe";
import { stripe } from "Config/config";

export default {
  name: "PlansModal",
  components: {
    StripeCheckout,
  },
  props: {
    openDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      planSelected: "",
      lineItems: [],
      publishableKey: stripe.pKey,
      successURL: `${window.location.origin}/subscriptions`,
      cancelURL: `${window.location.origin}/subscriptions`,
    };
  },
  computed: {
    ...mapGetters(["getAgent", "getPlans", "getSubscription"]),
  },
  watch: {
    openDialog(value) {
      this.dialog = value;
    },
  },
  async created() {
    this.dialog = this.openDialog;
  },
  methods: {
    ...mapActions(["updateSubscription"]),
    onCloseDialog() {
      this.$emit("update:openDialog", false);
    },
    async onSelectPlan(plan) {
      try {
        this.planSelected = plan;
        this.loading = true;

        if (this.getSubscription.type === "freemium" || this.getSubscription.cancel_at_period_end) {
          this.lineItems = this.getPlans[plan].lineItems;
          // You will be redirected to Stripe's secure checkout page
          this.$refs.checkoutRef.redirectToCheckout();
        } else {
          await this.updateSubscription({ stripe_price_id: this.getPlans[plan]?.lineItems[0].price });

          this.onCloseDialog();
          this.loading = false;
        }
      } catch (error) {
        console.error(error);
      }
    },
    onManageSubscription() {
      this.onCloseDialog();

      if (this.$route.name !== "subscriptions") this.$router.push({ name: "subscriptions" });
    },
  },
};
</script>
